import { render, staticRenderFns } from "./user-extension-wizard.vue?vue&type=template&id=2d6e9fc2"
import script from "./user-extension-wizard.vue?vue&type=script&lang=js"
export * from "./user-extension-wizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports